import {Button} from "@mui/material";
import React, {useState} from "react";
import {makeApolloClientCall} from "../../../../../api/makeApolloApiCall.js";
import {toast} from "react-toastify";


export const DOWNLOAD_SUMMARY_QUERY = `query PowertabsSubscriptions {
  powertabsSubscriptions {
    filePreFixName
    toEmail
    ccEmail
  }
}`

const HEADER_MAPPING = {
    filePreFixName: "Report Name",
    toEmail: "TO Recipients",
    ccEmail: "CC Recipients",
}

export const buildCsvContent = (subscriptions) => {
    const headers = Object.keys(subscriptions[0]).filter((key) => Object.keys(HEADER_MAPPING).includes(key));
    const csvRows = subscriptions.map(
        row => headers.map(header => Array.isArray(row[header]) ? row[header].join(';') : row[header]
        ).join(",")
    );
    return [Object.values(HEADER_MAPPING), ...csvRows].join('\n')
}

const createCsvFile = (csvContent) => {
    const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.setAttribute('href', url);
    link.setAttribute('download', "subscription-distro-list.csv");

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export const DownloadSubscriptionSummary = () => {
    const [isDisabled, setIsDisabled] = useState(false);
    const handleDownload = () => {
        setIsDisabled(true);
        makeApolloClientCall(DOWNLOAD_SUMMARY_QUERY, false)
            .then((result) => {
                createCsvFile(buildCsvContent(result.powertabsSubscriptions));
            })
            .catch((error) => toast.error(`${error}`)
            )
            .finally(() => {
                setIsDisabled(false);
            });
    }
    return (
        <div>
            <Button
                variant="outlined"
                disabled={isDisabled}
                onClick={handleDownload}
            >
                Download Distro List
            </Button>
        </div>
    )
}